// tslint:disable
/**
 * MapboxAPI
 * Mapbox API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AutoCompleteResponse
 */
export interface AutoCompleteResponse {
    /**
     * 
     * @type {Array<SearchResult>}
     * @memberof AutoCompleteResponse
     */
    features?: Array<SearchResult>;
}
/**
 * 
 * @export
 * @interface ContextItem
 */
export interface ContextItem {
    /**
     * 
     * @type {string}
     * @memberof ContextItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ContextItem
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof ContextItem
     */
    text_de?: string;
    /**
     * 
     * @type {string}
     * @memberof ContextItem
     */
    text_en?: string;
}
/**
 * 
 * @export
 * @interface DirectionResponse
 */
export interface DirectionResponse {
    /**
     * 
     * @type {Array<Route>}
     * @memberof DirectionResponse
     */
    routes?: Array<Route>;
    /**
     * 
     * @type {Array<Waypoint>}
     * @memberof DirectionResponse
     */
    waypoints?: Array<Waypoint>;
    /**
     * 
     * @type {string}
     * @memberof DirectionResponse
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof DirectionResponse
     */
    uuid?: string;
}
/**
 * 
 * @export
 * @interface Route
 */
export interface Route {
    /**
     * A float indicating the estimated travel time through the waypoints in seconds.
     * @type {number}
     * @memberof Route
     */
    duration?: number;
    /**
     * A float indicating the distance traveled through the waypoints in meters.
     * @type {number}
     * @memberof Route
     */
    distance?: number;
    /**
     * A string indicating which weight was used. The default is routability, which is duration-based, with additional penalties for less desirable maneuvers.
     * @type {string}
     * @memberof Route
     */
    weight_name?: string;
    /**
     * A float indicating the weight in units described by weight_name.
     * @type {number}
     * @memberof Route
     */
    weight?: number;
    /**
     * 
     * @type {RouteGeometry}
     * @memberof Route
     */
    geometry?: RouteGeometry;
}
/**
 * Depending on the geometries query parameter, this is either a GeoJSON LineString or a Polyline string. Depending on the overview query parameter, this is the complete route geometry (full), a simplified geometry to the zoom level at which the route can be displayed in full (simplified), or is not included (false).
 * @export
 * @interface RouteGeometry
 */
export interface RouteGeometry {
    /**
     * 
     * @type {Array<Array<number>>}
     * @memberof RouteGeometry
     */
    coordinates?: Array<Array<number>>;
    /**
     * 
     * @type {string}
     * @memberof RouteGeometry
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface SearchResult
 */
export interface SearchResult {
    /**
     * 
     * @type {string}
     * @memberof SearchResult
     */
    place_name?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchResult
     */
    place_name_de?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchResult
     */
    place_name_en?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchResult
     */
    center?: Array<number>;
    /**
     * 
     * @type {Array<ContextItem>}
     * @memberof SearchResult
     */
    context?: Array<ContextItem>;
    /**
     * 
     * @type {number}
     * @memberof SearchResult
     */
    address?: number;
}
/**
 * 
 * @export
 * @interface Waypoint
 */
export interface Waypoint {
    /**
     * A string with the name of the road or path to which the input coordinate has been snapped.
     * @type {string}
     * @memberof Waypoint
     */
    name: string;
    /**
     * An array containing the [longitude, latitude] of the snapped coordinate.
     * @type {Array<number>}
     * @memberof Waypoint
     */
    location: Array<number>;
    /**
     * The straight-line distance from the coordinate specified in the query to the location it was snapped to.
     * @type {number}
     * @memberof Waypoint
     */
    distance?: number;
}

/**
 * MapboxApi - axios parameter creator
 * @export
 */
export const MapboxApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} search 
         * @param {string} accessToken 
         * @param {boolean} [autocomplete] 
         * @param {string} [language] 
         * @param {string} [proximity] 
         * @param {string} [bbox] 
         * @param {number} [limit] 
         * @param {string} [types] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoComplete: async (search: string, accessToken: string, autocomplete?: boolean, language?: string, proximity?: string, bbox?: string, limit?: number, types?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            if (search === null || search === undefined) {
                throw new RequiredError('search','Required parameter search was null or undefined when calling autoComplete.');
            }
            // verify required parameter 'accessToken' is not null or undefined
            if (accessToken === null || accessToken === undefined) {
                throw new RequiredError('accessToken','Required parameter accessToken was null or undefined when calling autoComplete.');
            }
            const localVarPath = `/geocoding/v5/mapbox.places/{search}.json`
                .replace(`{${"search"}}`, encodeURIComponent(String(search)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accessToken !== undefined) {
                localVarQueryParameter['access_token'] = accessToken;
            }

            if (autocomplete !== undefined) {
                localVarQueryParameter['autocomplete'] = autocomplete;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (proximity !== undefined) {
                localVarQueryParameter['proximity'] = proximity;
            }

            if (bbox !== undefined) {
                localVarQueryParameter['bbox'] = bbox;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (types !== undefined) {
                localVarQueryParameter['types'] = types;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a direction between coordinates
         * @param {string} coordinates A semicolon-separated list of {longitude},{latitude} coordinate pairs to visit in order. There can be between 2 and 25 coordinates
         * @param {string} accessToken 
         * @param {boolean} [alternatives] Whether to try to return alternative routes or not (default). An alternative route is a route that is significantly different than the fastest route, but also still reasonably fast. Such a route does not exist in all circumstances. Up to two alternatives may be returned.
         * @param {'geojson' | 'polyline' | 'polyline6'} [geometries] The format of the returned geometry. Allowed values are: geojson (as LineString), polyline (a polyline with a precision of five decimal places), polyline6 (a polyline with a precision of six decimal places).
         * @param {'full' | 'simplified' | 'false'} [overview] Displays the requested type of overview geometry. Can be full (the most detailed geometry available), simplified (a simplified version of the full geometry), or false (no overview geometry).
         * @param {Array<'distance' | 'duration' | 'speed' | 'congestion' | 'maxspeed'>} [annotations] Return additional metadata along the route. Must be used in conjunction with overview&#x3D;full
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirection: async (coordinates: string, accessToken: string, alternatives?: boolean, geometries?: 'geojson' | 'polyline' | 'polyline6', overview?: 'full' | 'simplified' | 'false', annotations?: Array<'distance' | 'duration' | 'speed' | 'congestion' | 'maxspeed'>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'coordinates' is not null or undefined
            if (coordinates === null || coordinates === undefined) {
                throw new RequiredError('coordinates','Required parameter coordinates was null or undefined when calling getDirection.');
            }
            // verify required parameter 'accessToken' is not null or undefined
            if (accessToken === null || accessToken === undefined) {
                throw new RequiredError('accessToken','Required parameter accessToken was null or undefined when calling getDirection.');
            }
            const localVarPath = `/directions/v5/mapbox/driving/{coordinates}`
                .replace(`{${"coordinates"}}`, encodeURIComponent(String(coordinates)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accessToken !== undefined) {
                localVarQueryParameter['access_token'] = accessToken;
            }

            if (alternatives !== undefined) {
                localVarQueryParameter['alternatives'] = alternatives;
            }

            if (geometries !== undefined) {
                localVarQueryParameter['geometries'] = geometries;
            }

            if (overview !== undefined) {
                localVarQueryParameter['overview'] = overview;
            }

            if (annotations) {
                localVarQueryParameter['annotations'] = annotations.join(COLLECTION_FORMATS.csv);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} location 
         * @param {string} accessToken 
         * @param {string} [language] 
         * @param {number} [limit] 
         * @param {string} [types] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlaceName: async (location: Array<string>, accessToken: string, language?: string, limit?: number, types?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'location' is not null or undefined
            if (location === null || location === undefined) {
                throw new RequiredError('location','Required parameter location was null or undefined when calling searchPlaceName.');
            }
            // verify required parameter 'accessToken' is not null or undefined
            if (accessToken === null || accessToken === undefined) {
                throw new RequiredError('accessToken','Required parameter accessToken was null or undefined when calling searchPlaceName.');
            }
            const localVarPath = `/geocoding/v5/mapbox.places/{location}.json`
                .replace(`{${"location"}}`, encodeURIComponent(String(location)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accessToken !== undefined) {
                localVarQueryParameter['access_token'] = accessToken;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (types !== undefined) {
                localVarQueryParameter['types'] = types;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MapboxApi - functional programming interface
 * @export
 */
export const MapboxApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} search 
         * @param {string} accessToken 
         * @param {boolean} [autocomplete] 
         * @param {string} [language] 
         * @param {string} [proximity] 
         * @param {string} [bbox] 
         * @param {number} [limit] 
         * @param {string} [types] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autoComplete(search: string, accessToken: string, autocomplete?: boolean, language?: string, proximity?: string, bbox?: string, limit?: number, types?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutoCompleteResponse>> {
            const localVarAxiosArgs = await MapboxApiAxiosParamCreator(configuration).autoComplete(search, accessToken, autocomplete, language, proximity, bbox, limit, types, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary get a direction between coordinates
         * @param {string} coordinates A semicolon-separated list of {longitude},{latitude} coordinate pairs to visit in order. There can be between 2 and 25 coordinates
         * @param {string} accessToken 
         * @param {boolean} [alternatives] Whether to try to return alternative routes or not (default). An alternative route is a route that is significantly different than the fastest route, but also still reasonably fast. Such a route does not exist in all circumstances. Up to two alternatives may be returned.
         * @param {'geojson' | 'polyline' | 'polyline6'} [geometries] The format of the returned geometry. Allowed values are: geojson (as LineString), polyline (a polyline with a precision of five decimal places), polyline6 (a polyline with a precision of six decimal places).
         * @param {'full' | 'simplified' | 'false'} [overview] Displays the requested type of overview geometry. Can be full (the most detailed geometry available), simplified (a simplified version of the full geometry), or false (no overview geometry).
         * @param {Array<'distance' | 'duration' | 'speed' | 'congestion' | 'maxspeed'>} [annotations] Return additional metadata along the route. Must be used in conjunction with overview&#x3D;full
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirection(coordinates: string, accessToken: string, alternatives?: boolean, geometries?: 'geojson' | 'polyline' | 'polyline6', overview?: 'full' | 'simplified' | 'false', annotations?: Array<'distance' | 'duration' | 'speed' | 'congestion' | 'maxspeed'>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutoCompleteResponse>> {
            const localVarAxiosArgs = await MapboxApiAxiosParamCreator(configuration).getDirection(coordinates, accessToken, alternatives, geometries, overview, annotations, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<string>} location 
         * @param {string} accessToken 
         * @param {string} [language] 
         * @param {number} [limit] 
         * @param {string} [types] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPlaceName(location: Array<string>, accessToken: string, language?: string, limit?: number, types?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutoCompleteResponse>> {
            const localVarAxiosArgs = await MapboxApiAxiosParamCreator(configuration).searchPlaceName(location, accessToken, language, limit, types, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MapboxApi - factory interface
 * @export
 */
export const MapboxApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} search 
         * @param {string} accessToken 
         * @param {boolean} [autocomplete] 
         * @param {string} [language] 
         * @param {string} [proximity] 
         * @param {string} [bbox] 
         * @param {number} [limit] 
         * @param {string} [types] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoComplete(search: string, accessToken: string, autocomplete?: boolean, language?: string, proximity?: string, bbox?: string, limit?: number, types?: string, options?: any): AxiosPromise<AutoCompleteResponse> {
            return MapboxApiFp(configuration).autoComplete(search, accessToken, autocomplete, language, proximity, bbox, limit, types, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a direction between coordinates
         * @param {string} coordinates A semicolon-separated list of {longitude},{latitude} coordinate pairs to visit in order. There can be between 2 and 25 coordinates
         * @param {string} accessToken 
         * @param {boolean} [alternatives] Whether to try to return alternative routes or not (default). An alternative route is a route that is significantly different than the fastest route, but also still reasonably fast. Such a route does not exist in all circumstances. Up to two alternatives may be returned.
         * @param {'geojson' | 'polyline' | 'polyline6'} [geometries] The format of the returned geometry. Allowed values are: geojson (as LineString), polyline (a polyline with a precision of five decimal places), polyline6 (a polyline with a precision of six decimal places).
         * @param {'full' | 'simplified' | 'false'} [overview] Displays the requested type of overview geometry. Can be full (the most detailed geometry available), simplified (a simplified version of the full geometry), or false (no overview geometry).
         * @param {Array<'distance' | 'duration' | 'speed' | 'congestion' | 'maxspeed'>} [annotations] Return additional metadata along the route. Must be used in conjunction with overview&#x3D;full
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirection(coordinates: string, accessToken: string, alternatives?: boolean, geometries?: 'geojson' | 'polyline' | 'polyline6', overview?: 'full' | 'simplified' | 'false', annotations?: Array<'distance' | 'duration' | 'speed' | 'congestion' | 'maxspeed'>, options?: any): AxiosPromise<AutoCompleteResponse> {
            return MapboxApiFp(configuration).getDirection(coordinates, accessToken, alternatives, geometries, overview, annotations, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} location 
         * @param {string} accessToken 
         * @param {string} [language] 
         * @param {number} [limit] 
         * @param {string} [types] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlaceName(location: Array<string>, accessToken: string, language?: string, limit?: number, types?: string, options?: any): AxiosPromise<AutoCompleteResponse> {
            return MapboxApiFp(configuration).searchPlaceName(location, accessToken, language, limit, types, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MapboxApi - object-oriented interface
 * @export
 * @class MapboxApi
 * @extends {BaseAPI}
 */
export class MapboxApi extends BaseAPI {
    /**
     * 
     * @param {string} search 
     * @param {string} accessToken 
     * @param {boolean} [autocomplete] 
     * @param {string} [language] 
     * @param {string} [proximity] 
     * @param {string} [bbox] 
     * @param {number} [limit] 
     * @param {string} [types] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapboxApi
     */
    public autoComplete(search: string, accessToken: string, autocomplete?: boolean, language?: string, proximity?: string, bbox?: string, limit?: number, types?: string, options?: any) {
        return MapboxApiFp(this.configuration).autoComplete(search, accessToken, autocomplete, language, proximity, bbox, limit, types, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a direction between coordinates
     * @param {string} coordinates A semicolon-separated list of {longitude},{latitude} coordinate pairs to visit in order. There can be between 2 and 25 coordinates
     * @param {string} accessToken 
     * @param {boolean} [alternatives] Whether to try to return alternative routes or not (default). An alternative route is a route that is significantly different than the fastest route, but also still reasonably fast. Such a route does not exist in all circumstances. Up to two alternatives may be returned.
     * @param {'geojson' | 'polyline' | 'polyline6'} [geometries] The format of the returned geometry. Allowed values are: geojson (as LineString), polyline (a polyline with a precision of five decimal places), polyline6 (a polyline with a precision of six decimal places).
     * @param {'full' | 'simplified' | 'false'} [overview] Displays the requested type of overview geometry. Can be full (the most detailed geometry available), simplified (a simplified version of the full geometry), or false (no overview geometry).
     * @param {Array<'distance' | 'duration' | 'speed' | 'congestion' | 'maxspeed'>} [annotations] Return additional metadata along the route. Must be used in conjunction with overview&#x3D;full
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapboxApi
     */
    public getDirection(coordinates: string, accessToken: string, alternatives?: boolean, geometries?: 'geojson' | 'polyline' | 'polyline6', overview?: 'full' | 'simplified' | 'false', annotations?: Array<'distance' | 'duration' | 'speed' | 'congestion' | 'maxspeed'>, options?: any) {
        return MapboxApiFp(this.configuration).getDirection(coordinates, accessToken, alternatives, geometries, overview, annotations, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} location 
     * @param {string} accessToken 
     * @param {string} [language] 
     * @param {number} [limit] 
     * @param {string} [types] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapboxApi
     */
    public searchPlaceName(location: Array<string>, accessToken: string, language?: string, limit?: number, types?: string, options?: any) {
        return MapboxApiFp(this.configuration).searchPlaceName(location, accessToken, language, limit, types, options).then((request) => request(this.axios, this.basePath));
    }

}


